<template>
    <div class="page page-exam">
        <!--答题模式-->
        <template v-if="form.answer">
            <div class="page__bd">
                <template v-if="started">
                    <div class="question-card" v-if="selected">
                        <div class="question-header">
                            <span class="text-bold">{{ selected.eq_detno }}. {{ selected.eq_qustem }}</span>
                            <span class="text-warn">[{{ selected.title }}]</span>
                            <span class="text-muted"> ({{ selected.eq_quscore }}分)</span>
                        </div>
                        <div class="question-body">
                            <template v-if="selected.eq_qutype < 3">
                                <div class="weui-cells weui-cells_checkbox">
                                    <label class="weui-cell weui-cell_active weui-check__label"
                                        v-for="(option, index) in selected.options" :key="option.text"
                                        @click.prevent="selectOption(index)">
                                        <div class="weui-cell__hd">
                                            <input type="checkbox" class="weui-check" v-model="option.selected" />
                                            <i class="weui-icon-checked"></i>
                                        </div>
                                        <div class="weui-cell__bd">
                                            <p>{{ option.code }}. {{ option.text }}</p>
                                        </div>
                                    </label>
                                </div>
                            </template>
                            <template v-else>
                                <div class="input-box">
                                    <textarea class="weui-textarea" placeholder="请填写答案" v-model="selected.eq_answer"
                                        rows="5"></textarea>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div class="question-footer">
                        <div class="weui-flex__center">
                            <a href="javascript:;" class="weui-btn weui-btn_mini weui-btn_default"
                                :class="{ 'weui-btn_disabled': !selectedIndex }"
                                @click="selectedIndex && selectQuestion(selectedIndex - 1)">上一题</a>
                        </div>
                        <div class="weui-flex__item weui-flex__center">
                            <a href="javascript:;" class="weui-btn weui-btn_mini weui-btn_primary"
                                @click="confirmEndExam">提交试卷</a>
                        </div>
                        <div class="weui-flex__center">
                            <a href="javascript:;" class="weui-btn weui-btn_mini weui-btn_default"
                                :class="{ 'weui-btn_disabled': selectedIndex == form.items.length - 1 }"
                                @click="selectedIndex != form.items.length - 1 && selectQuestion(selectedIndex + 1)">下一题</a>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="weui-form-preview">
                        <div role="option" class="weui-form-preview__bd">
                            <div class="weui-form-preview__item">
                                <label class="weui-form-preview__label">考试</label>
                                <span class="weui-form-preview__value">{{ form.main.ex_name }}</span>
                            </div>
                            <div class="weui-form-preview__item">
                                <label class="weui-form-preview__label">试卷</label>
                                <span class="weui-form-preview__value">{{ form.main.eu_epname }}</span>
                            </div>
                            <div class="weui-form-preview__item">
                                <label class="weui-form-preview__label">考生</label>
                                <span class="weui-form-preview__value">{{ form.main.eu_emname }}</span>
                            </div>
                            <div class="weui-form-preview__item" v-if="form.main.ex_type">
                                <label class="weui-form-preview__label">开始时间</label>
                                <span class="weui-form-preview__value">{{ form.main.ex_begin }}</span>
                            </div>
                            <div class="weui-form-preview__item" v-if="form.main.ex_type">
                                <label class="weui-form-preview__label">结束时间</label>
                                <span class="weui-form-preview__value">{{ form.main.ex_end }}</span>
                            </div>
                            <div class="weui-form-preview__item">
                                <label class="weui-form-preview__label">限制时长</label>
                                <span class="weui-form-preview__value">{{ form.main.ex_limit }} 分钟</span>
                            </div>
                        </div>
                        <div class="weui-form-preview__ft">
                            <a role="button" class="weui-form-preview__btn weui-form-preview__btn_primary"
                                href="javascript:" @click="allowStart && startExam()">{{ form.main.eu_status ? '继续考试' :
            '开始考试' }}</a>
                        </div>
                    </div>
                </template>
            </div>
            <div class="page__ft weui-flex" v-if="started">
                <div>
                    <span class="text-muted">剩余时间：</span>
                    <span>{{ leftTimeStr }}</span>
                </div>
                <div class="weui-flex__item"></div>
                <div>
                    <a href="javascript:;" class="text-link" @click="showQuestionIndex = true">
                        <span class="iconfont icon-folder"></span>
                        <span>&nbsp;{{ selected.eq_detno }} / {{ form.total }}</span>
                    </a>
                </div>
            </div>
        </template>
        <!--阅卷模式-->
        <template v-else-if="form.review">
            <div class="page__bd">
                <template v-if="started">
                    <div class="question-card" v-if="selected">
                        <div class="question-header">
                            <span class="text-bold">{{ selected.eq_detno }}. {{ selected.eq_qustem }}</span>
                            <span class="text-warn">[{{ selected.title }}]</span>
                            <span class="text-muted"> ({{ selected.eq_quscore }}分)</span>
                        </div>
                        <div class="question-body">
                            <div class="box box-default">
                                <span class="text-bold">回答：</span>
                                <span>{{ selected.eq_answer }}</span>
                            </div>
                            <div class="box box-info">
                                <span class="text-bold">参考答案：</span>
                                <span>{{ selected.eq_quanswer }}</span>
                            </div>
                            <div class="weui-cells">
                                <label class="weui-cell weui-cell_active">
                                    <div class="weui-cell__hd"><span class="weui-label">评分</span></div>
                                    <div class="weui-cell__bd weui-flex">
                                        <input class="weui-input" type="number" placeholder="请输入评分" v-model="selected.eq_score" />
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="question-footer">
                        <div class="weui-flex__center">
                            <a href="javascript:;" class="weui-btn weui-btn_mini weui-btn_default"
                                :class="{ 'weui-btn_disabled': !selectedIndex }"
                                @click="selectedIndex && selectQuestion(selectedIndex - 1)">上一题</a>
                        </div>
                        <div class="weui-flex__item weui-flex__center">
                            <a href="javascript:;" class="weui-btn weui-btn_mini weui-btn_primary"
                                @click="confirmReview">完成阅卷</a>
                        </div>
                        <div class="weui-flex__center">
                            <a href="javascript:;" class="weui-btn weui-btn_mini weui-btn_default"
                                :class="{ 'weui-btn_disabled': selectedIndex == form.items.length - 1 }"
                                @click="selectedIndex != form.items.length - 1 && selectQuestion(selectedIndex + 1)">下一题</a>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="weui-form-preview">
                        <div role="option" class="weui-form-preview__bd">
                            <div class="weui-form-preview__item">
                                <label class="weui-form-preview__label">考试</label>
                                <span class="weui-form-preview__value">{{ form.main.ex_name }}</span>
                            </div>
                            <div class="weui-form-preview__item">
                                <label class="weui-form-preview__label">试卷</label>
                                <span class="weui-form-preview__value">{{ form.main.eu_epname }}</span>
                            </div>
                            <div class="weui-form-preview__item">
                                <label class="weui-form-preview__label">考生</label>
                                <span class="weui-form-preview__value">{{ form.main.eu_emname }}</span>
                            </div>
                            <div class="weui-form-preview__item">
                                <label class="weui-form-preview__label">开始时间</label>
                                <span class="weui-form-preview__value">{{ form.main.eu_begin }}</span>
                            </div>
                            <div class="weui-form-preview__item">
                                <label class="weui-form-preview__label">完成时间</label>
                                <span class="weui-form-preview__value">{{ form.main.eu_end }}</span>
                            </div>
                        </div>
                        <div class="weui-form-preview__ft">
                            <a role="button" class="weui-form-preview__btn weui-form-preview__btn_primary"
                                href="javascript:" @click="startReview">开始阅卷</a>
                        </div>
                    </div>
                </template>
            </div>
            <div class="page__ft weui-flex" v-if="started">
                <div>
                    <a href="javascript:;" class="text-link" @click="showMainInfo = true">
                        <span>{{ form.main.ex_name }}&nbsp;</span>
                        <span class="iconfont icon-eye"></span>
                    </a>
                </div>
                <div class="weui-flex__item"></div>
                <div>
                    <a href="javascript:;" class="text-link" @click="showQuestionIndex = true">
                        <span class="iconfont icon-folder"></span>
                        <span>&nbsp;{{ selected.eq_detno }} / {{ form.total }}</span>
                    </a>
                </div>
            </div>
        </template>
        <!--只读模式-->
        <template class="page__bd" v-else-if="form.main.eu_id">
            <div class="page__bd">
                <div class="question-card" v-if="selected">
                    <div class="question-header">
                        <span class="text-bold">{{ selected.eq_detno }}. {{ selected.eq_qustem }}</span>
                        <span class="text-warn">[{{ selected.title }}]</span>
                        <span class="text-muted"> ({{ selected.eq_quscore }}分)</span>
                    </div>
                    <div class="question-body">
                        <template v-if="selected.eq_qutype < 3">
                            <div class="weui-cells weui-cells_checkbox">
                                <label class="weui-cell weui-cell_active weui-check__label"
                                    v-for="(option) in selected.options" :key="option.text">
                                    <div class="weui-cell__hd">
                                        <input type="checkbox" class="weui-check" v-model="option.selected" disabled />
                                        <i class="weui-icon-checked"></i>
                                    </div>
                                    <div class="weui-cell__bd">
                                        <p>{{ option.code }}. {{ option.text }}</p>
                                    </div>
                                </label>
                            </div>
                            <div class="box box-info" v-if="selected.eq_score">
                                <span>答对了</span>
                            </div>
                            <div class="box box-warn" v-if="selected.eq_score == 0">
                                <div>答错了</div>
                                <div>正确答案：{{ selected.eq_quanswer_code }}</div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="box box-default">
                                <div>
                                    <span class="text-bold">回答：</span>
                                    <span>{{ selected.eq_answer }}</span>
                                </div>
                                <div class="text-bold">
                                    <span>得分：</span>
                                    <span class="text-warn" v-if="selected.eq_score == null">待批阅</span>
                                    <span :class="selected.eq_score ? 'text-success' : 'text-warn'" v-else>{{
            selected.eq_score }}</span>
                                </div>
                            </div>
                            <div class="box box-info">
                                <span class="text-bold">参考答案：</span>
                                <span>{{ selected.eq_quanswer }}</span>
                            </div>
                        </template>
                    </div>
                </div>
                <div class="question-footer weui-flex">
                    <div>
                        <a v-if="selectedIndex" href="javascript:;" class="weui-btn weui-btn_mini weui-btn_default"
                            @click="selectQuestion(selectedIndex - 1)">上一题</a>

                    </div>
                    <div class="weui-flex__item"></div>
                    <div>
                        <a v-if="selectedIndex != form.items.length - 1" href="javascript:;"
                            class="weui-btn weui-btn_mini weui-btn_default"
                            @click="selectQuestion(selectedIndex + 1)">下一题</a>
                    </div>
                </div>
            </div>
            <div class="page__ft weui-flex">
                <div>
                    <a href="javascript:;" class="text-link" @click="showMainInfo = true">
                        <span>{{ form.main.ex_name }}&nbsp;</span>
                        <span class="iconfont icon-eye"></span>
                    </a>
                </div>
                <div class="weui-flex__item"></div>
                <div>
                    <a href="javascript:;" class="text-link" @click="showQuestionIndex = true">
                        <span class="iconfont icon-folder"></span>
                        <span>&nbsp;{{ selected.eq_detno }} / {{ form.total }}</span>
                    </a>
                </div>
            </div>
        </template>
        <div v-if="showMainInfo" role="dialog" aria-modal="true" aria-hidden="false">
            <div class="weui-mask weui-transition" @click="showMainInfo = false"></div>
            <div class="weui-half-screen-dialog weui-half-screen-dialog_show weui-transition">
                <div class="weui-half-screen-dialog__hd">
                    <div class="weui-half-screen-dialog__hd__side">
                        <div class="weui-btn_icon" @click="showMainInfo = false">关闭<i class="weui-icon-close-thin"></i>
                        </div>
                    </div>
                    <div class="weui-half-screen-dialog__hd__main">
                        <strong class="weui-half-screen-dialog__title">考试信息</strong>
                    </div>
                </div>
                <div class="weui-half-screen-dialog__bd">
                    <div class="form-preview weui-form-preview">
                        <div class="weui-form-preview__bd">
                            <div class="weui-form-preview__item">
                                <label class="weui-form-preview__label">考试</label>
                                <span class="weui-form-preview__value">{{ form.main.ex_name }}</span>
                            </div>
                            <div class="weui-form-preview__item">
                                <label class="weui-form-preview__label">试卷</label>
                                <span class="weui-form-preview__value">{{ form.main.eu_epname }}</span>
                            </div>
                            <div class="weui-form-preview__item">
                                <label class="weui-form-preview__label">考生</label>
                                <span class="weui-form-preview__value">{{ form.main.eu_emname }}</span>
                            </div>
                            <div class="weui-form-preview__item" v-if="form.main.eu_begin">
                                <label class="weui-form-preview__label">开始时间</label>
                                <span class="weui-form-preview__value">{{ form.main.eu_begin }}</span>
                            </div>
                            <div class="weui-form-preview__item" v-if="form.main.eu_end">
                                <label class="weui-form-preview__label">完成时间</label>
                                <span class="weui-form-preview__value">{{ form.main.eu_end }}</span>
                            </div>
                            <div class="weui-form-preview__item" v-if="form.main.eu_status >= 2">
                                <label class="weui-form-preview__label">得分</label>
                                <span class="weui-form-preview__value">{{ form.main.eu_status == 3 ?
            form.main.eu_score : '待批阅'
                                    }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showQuestionIndex" role="dialog" aria-modal="true" aria-hidden="false">
            <div class="weui-mask weui-transition" @click="showQuestionIndex = false"></div>
            <div class="weui-half-screen-dialog weui-half-screen-dialog_show weui-transition">
                <div class="weui-half-screen-dialog__hd">
                    <div class="weui-half-screen-dialog__hd__side">
                        <div class="weui-btn_icon" @click="showQuestionIndex = false">关闭<i
                                class="weui-icon-close-thin"></i>
                        </div>
                    </div>
                    <div class="weui-half-screen-dialog__hd__main">
                        <strong class="weui-half-screen-dialog__title">考试题目</strong>
                    </div>
                </div>
                <div class="weui-half-screen-dialog__bd">
                    <div class="question-index-list">
                        <div v-for="(item, index) in form.items" :key="item.id" class="question-index-item"
                            :class="getIndexClass(index)" @click="selectQuestion(index)">
                            {{ item.eq_detno }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                answer: false,
                review: false,
                main: {},
                items: []
            },
            clientTime: 0,
            allowStart: false,
            planStartTime: 0,
            planEndTime: 0,
            started: false,
            leftTimeStr: null,
            selected: null,
            selectedIndex: 0,
            showMainInfo: false,
            showQuestionIndex: false
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.loadData();
        });
    },
    beforeDestroy() {
        clearInterval(this.checkStartInterval)
        clearInterval(this.checkEndInterval)
    },
    methods: {
        loadData() {
            const me = this, id = me.$route.params.id;
            me.$loading({
                url: '/api/oa/exam_user/read/' + id
            }).then(function (res) {
                if (res.data) {
                    me.setData(res.data)
                } else {
                    me.$router.push({
                        name: "Error",
                        params: res
                    });
                }
            })
        },
        setData(form) {
            let items = form.items || []
            if (form.review) {
                items = items.filter(item => item.eq_score == null)
            }
            items.forEach(item => {
                item.title = ['单选题', '多选题', '判断题', '问答题'][item.eq_qutype]
                let options = [];
                if (item.eq_quoptions) {
                    options = JSON.parse(item.eq_quoptions).map(text => {
                        return {
                            text,
                            selected: false
                        }
                    });
                    options.forEach((option, index) => {
                        option.code = String.fromCharCode(65 + index);
                    });
                    item.options = options
                }
                if (form.main.eu_status > 1) {
                    if (item.eq_answer) {
                        let selected = {}
                        item.eq_answer.split(',').forEach(i => {
                            selected[Number(i)] = true
                        })
                        options.forEach((option, index) => {
                            option.selected = !!selected[index]
                        })
                        selected = {}
                        item.eq_quanswer.split(',').forEach(i => {
                            selected[Number(i)] = true
                        })
                        item.eq_quanswer_code = options.filter((option, index) => selected[index]).map(option => option.code).join('、')
                    }
                } else {
                    item.eq_answer = null
                }
            })
            form.items = items
            form.total = items.length
            this.form = form
            if (form.answer && !this.started) {
                this.checkStart()
            } else if (!form.review && form.main.eu_status && form.total) {
                this.selectQuestion(0)
            }
        },
        checkStart() {
            const me = this, { ex_type, ex_begin, ex_end, serverTime } = me.form.main
            me.allowStart = ex_type == 0
            if (!me.allowStart) {
                me.planStartTime = new Date(ex_begin.replace(/-/g, '/')).getTime()
                me.planEndTime = new Date(ex_end.replace(/-/g, '/')).getTime()
                me.allowStart = serverTime >= me.planStartTime && serverTime < me.planEndTime
                if (serverTime < me.planStartTime) {
                    me.planStartTime = new Date(me.form.main.ex_begin.replace(/-/g, '/')).getTime()
                    me.allowStart = me.form.main.serverTime >= me.planStartTime
                    me.checkStartInterval = setInterval(() => {
                        me.clientTime += 1000
                        if (!me.started && !me.allowStart && me.clientTime >= me.planStartTime) {
                            me.allowStart = true
                        } else if (!me.started && me.allowStart && me.clientTime > me.planEndTime) {
                            me.allowStart = false
                        }
                    }, 1000);
                }
            }
        },
        checkEnd() {
            const me = this
            let { ex_type, ex_end, eu_begin, ex_limit, serverTime } = me.form.main
            me.clientDiff = Date.now() - serverTime
            me.startTime = eu_begin
            if (ex_type) {
                me.planEndTime = new Date(ex_end.replace(/-/g, '/')).getTime() + me.clientDiff
            } else {
                me.planEndTime = new Date(eu_begin.replace(/-/g, '/')).getTime() + ex_limit * 60000 + me.clientDiff
            }
            me.updateLeftTime()
            me.checkEndInterval = setInterval(() => {
                if (Date.now() >= me.planEndTime) {
                    me.autoConfirmEndExam()
                    me.checkEndInterval = clearInterval(me.checkEndInterval)
                } else {
                    me.updateLeftTime()
                }
            }, 1000);
        },
        updateLeftTime() {
            const me = this
            me.leftTime = me.planEndTime - Date.now()
            let time = Math.floor(me.leftTime / 1000), minute = Math.floor(time / 60)
            me.leftTimeStr = (minute ? minute + '分' : '') + (time % 60) + '秒'
        },
        startExam() {
            const me = this
            me.$loading({
                url: '/api/oa/exam_user/start/' + me.form.main.eu_id,
                method: 'POST'
            }).then(function (res) {
                if (res.data) {
                    me.started = true
                    res.data.answer = true
                    res.data.review = false
                    me.setData(res.data)
                    me.checkStartInterval = clearInterval(me.checkStartInterval)
                    if (me.form.items.length) {
                        me.$nextTick(() => me.selectQuestion(0))
                    }
                    me.checkEnd()
                } else {
                    me.$weui.topTips("操作失败：" + res.message, 3000);
                }
            });
        },
        endExam() {
            let me = this, form = me.form, answers = {};
            form.items.forEach(item => answers[item.id] = item.eq_answer)
            return me.$loading({
                url: "/api/oa/exam_user/end",
                method: 'post',
                jsonData: {
                    eu_id: form.main.eu_id,
                    answers
                }
            }).then(function (res) {
                if (res.success) {
                    me.$weui.toast("提交成功", 2000)
                    me.started = false
                    me.checkEndInterval = clearInterval(me.checkEndInterval)
                } else {
                    me.$weui.topTips("提交失败：" + res.message, 3000);
                }
                return res
            });
        },
        autoConfirmEndExam() {
            let me = this;
            me.endExam().then(function (res) {
                if (res.success) {
                    me.$weui.alert('考试时间已经结束，试卷自动提交成功',
                        {
                            title: "提示",
                            buttons: [
                                {
                                    label: "知道了",
                                    type: "primary",
                                    onClick: function () {
                                        me.loadData()
                                    }
                                }
                            ],
                        }
                    );
                }
            })
        },
        confirmEndExam() {
            const me = this
            me.$weui.confirm('确认完成答题，并提交试卷？', function () {
                me.endExam().then(function (res) {
                    if (res.success) {
                        me.loadData()
                    }
                })
            });
        },
        startReview() {
            this.started = true
            this.selectQuestion(0)
        },
        confirmReview() {
            let me = this, items = me.form.items, total = items.length, finished = items.filter(item => item.eq_score != null && item.eq_score != '').length;
            if (finished < total) {
                me.$weui.topTips("有未完成评分的题目", 3000);
                return
            }
            let error = items.filter(item => item.eq_score < 0 || item.eq_score > item.eq_quscore).map(item => item.eq_detno).join(',')
            if (error) {
                me.$weui.topTips(`第${error}题分数错误`, 3000);
                return
            }
            me.$weui.confirm('确认完成批阅？', function () {
                me.reviewExam()
            });
        },
        reviewExam() {
            let me = this, form = me.form, scores = {};
            form.items.forEach(item => scores[item.id] = item.eq_score)
            return me.$loading({
                url: "/api/oa/exam_user/review",
                method: 'post',
                jsonData: {
                    eu_id: form.main.eu_id,
                    scores
                }
            }).then(function (res) {
                if (res.success) {
                    me.$weui.toast("提交成功", 2000)
                    me.started = false
                    me.loadData()
                } else {
                    me.$weui.topTips("提交失败：" + res.message, 3000);
                }
            });
        },
        selectQuestion(selectedIndex) {
            this.selectedIndex = selectedIndex
            this.selected = this.form.items[this.selectedIndex]
            this.showQuestionIndex = false
        },
        selectOption(index) {
            let qu_type = this.selected.eq_qutype, options = this.selected.options
            if (qu_type == 1) {
                options[index].selected = !options[index].selected;
            } else {
                options.forEach((option, i) => {
                    option.selected = i == index
                })
            }
            let answer = []
            options.forEach((option, index) => {
                if (option.selected) {
                    answer.push(index)
                }
            })
            this.selected.eq_answer = answer.join(',')
        },
        getIndexClass(index) {
            const me = this, item = me.form.items[index]
            if (me.form.answer) {
                if (item.eq_answer) {
                    return 'text-success';
                }
            } else if (me.form.review) {
                if (item.eq_score != null && item.eq_score != '') {
                    return 'text-success';
                }
            } else {
                if (item.eq_score == 0) {
                    return 'text-error';
                }
                if (item.eq_score > 0) {
                    return 'text-success';
                }
            }
        }
    }
}
</script>
<style>
.page-exam {
    display: flex;
    flex-direction: column;
    background-color: var(--weui-BG-5);
}

.page-exam .page__bd {
    flex: 1;
    display: flex;
    flex-direction: column;
    font-size: 16px;
}

.question-card {
    flex: 1;
    padding: 20px;
    overflow-y: auto;
}

.question-card .weui-cells {
    font-size: 16px;
}

.question-card .weui-cell {
    padding: 10px;
}

.question-header {
    margin-bottom: 10px;
}

.question-footer {
    padding: 10px 20px;
    display: flex;
    justify-content: center;
}

.question-footer .weui-btn {
    margin: 0;
}

.page__ft {
    background-color: var(--weui-BG-1);
    overflow: hidden;
    padding: 10px 20px;
    position: relative;
    font-size: 14px;
}

.page__ft:before {
    content: " ";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 1px;
    border-top: 1px solid #c0bfc4;
    color: #c0bfc4;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
}

.question-index-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.question-index-item {
    height: 30px;
    line-height: 30px;
    width: 30px;
    border-radius: 50%;
    border: 1px solid var(--weui-FG-3);
    text-align: center;
    margin-right: 10px;
}
</style>